import React from 'react';
import { Sun, BatteryCharging, Car, Zap, Wrench, House } from 'lucide-react';

// Maps a job's install types to relatable icons:
//   solar → Sun, battery → Battery, ev → Car, electrical → Zap, other → Wrench.
// A solar+battery job shows both a Sun and a Battery.
const TYPE_ICON = {
  solar: Sun,
  battery: BatteryCharging,
  ev: Car,
  electrical: Zap,
  other: Wrench,
};

export const jobTypeList = (job) => {
  if (Array.isArray(job?.job_types) && job.job_types.length) return job.job_types;
  // Fallback: derive from raw system-type flags if job_types wasn't provided.
  const t = [];
  if (job?.system_type_solar || job?.system_type_solar_battery) t.push('solar');
  if (job?.system_type_battery_only || job?.system_type_solar_battery) t.push('battery');
  if ((job?.ev_charger_quantity || 0) > 0 || job?.ev_charger_manufacturer) t.push('ev');
  if (job?.system_type_electrical) t.push('electrical');
  if (job?.system_type_other) t.push('other');
  return t;
};

// Renders the icon(s) for a job. Defaults to a House when nothing is specified.
export const JobIcon = ({ job, className = 'w-4 h-4' }) => {
  const types = jobTypeList(job);
  if (!types.length) return <House className={className} />;
  return (
    <span className="inline-flex items-center gap-0.5">
      {types.map((t) => {
        const Ic = TYPE_ICON[t] || House;
        return <Ic key={t} className={className} />;
      })}
    </span>
  );
};

export default JobIcon;
